import React, { useState } from "react";
import { Card, CardImgOverlay, CardTitle, CardText, CardImg } from "reactstrap";
import bg from "../assets/galaxy_big.jpg";

export const HeaderCard = () => {
  const [value, setValue] = useState(0);
  let titleStyle = {};
  const centerStyle = {
    transition: "0.5s",
    fontSize: "large",
    width: "100%",
    marginBottom: "10px",
    paddingTop: "2vw",
  };
  const leftStyle = {
    transition: "0.1s",
    width: "30%",
  };

  const centerStyleMobile = {
    transition: "0.5s",
    width: "100%",
    marginBottom: "0px",
    fontSize: "12px",
  };

  const centerText = () => {
    titleStyle = centerStyle;
    setValue((value) => ++value);
  };
  const leftText = () => {
    titleStyle = leftStyle;
    setValue((value) => ++value);
  };

  let mobile = window.screen.width <= 440 ? true : false;

  return !mobile ? (
    <>
      <Card className="bg-dark text-white">
        <CardImg src={bg} alt="..." />
        <CardImgOverlay
          className="card-overlay"
          onMouseEnter={centerText}
          onMouseLeave={leftText}
        >
          <CardTitle
            className={value % 2 == 0 ? "text-left" : "text-center"}
            style={value % 2 == 0 ? leftStyle : centerStyle}
          >
            Lisk Observer{" "}
          </CardTitle>
          <CardText
            className={
              (value % 2 == 0 ? "text-left" : "text-center") + " text-white"
            }
            style={value % 2 == 0 ? leftStyle : centerStyle}
          >
            The Lisk ecosystem is a galaxy of interconnected blockchains, like
            little planets communicating between each other.
          </CardText>
          <CardText
            className={
              (value % 2 == 0 ? "text-left" : "text-center") + " text-white"
            }
            style={value % 2 == 0 ? leftStyle : centerStyle}
          >
            The data is fetched in realtime from the Lisk blockchain and
            sidechains.
          </CardText>
        </CardImgOverlay>
      </Card>
    </>
  ) : (
    <>
      <Card className="bg-dark text-white">
        <CardImg src={bg} alt="..." />
        <CardImgOverlay
          className="card-overlay"
          onMouseEnter={centerText}
          onMouseLeave={leftText}
        >
          <CardTitle className={"text-center"} style={centerStyleMobile}>
            Lisk Observer{" "}
          </CardTitle>
          <CardText className={"text-center"} style={centerStyleMobile}>
            The Lisk ecosystem is an of interconnected blockchains, like little
            planets.
          </CardText>
          <CardText className={"text-center"} style={centerStyleMobile}>
            Last data update 3 sec ago
          </CardText>
        </CardImgOverlay>
      </Card>
    </>
  );
};
